module.exports = __webpack_public_path__ + "assets/img/21eac61c61977d72d894684e0f62657f.svg";